export const METRICS = {
    registrations: 'Регистрации',
    payments:'Оплаты', 
    transactions: 'Списания',
  };
  
  export const METRIC_SLUGS = {
    registrations: 'registrations',
    payments: 'payments',
    transactions: 'transactions',
  };
  
  export const COLORS = {
    registrations: '#3b82f6',
    payments: ['#10b981', '#22d3ee'],
    transactions: '#5ecb05ff',
  };
  
  export const AVERAGE_METRICS = {
    averageViewCost:'averageViewCost',
    averageContactCost:'averageContactCost', 
  };


  export const RUBLE_METRIC = {
    payments: 'payments',
    transactions: 'transactions',
  };
  